import NotFound from '@/components/errors/not_found.vue';

export default [
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
  },
];
